import React from 'react';
import CopyButton from './CopyButton';
import { components, palette } from '../utils/designTokens';

/**
 * SystemPromptPanel - Displays agent system prompt or tool description with formatting
 * Extracted from DetailsTab.js to be reusable in drawers/modals
 *
 * @param {string} systemPrompt - The system prompt or description text
 * @param {string} title - Optional title (defaults to "System Prompt")
 */
export default function SystemPromptPanel({ systemPrompt, title = 'System Prompt' }) {
  const isSystemPrompt = title === 'System Prompt';

  return (
    <div
      className="rounded-lg p-4 border flex flex-col h-full"
      style={{
        backgroundColor: palette.neutrals.panelSecondary,
        borderColor: palette.borders.subtle,
      }}
    >
      <div className="flex items-center justify-between mb-3 flex-shrink-0">
        <h4 className="text-sm font-semibold text-text-heading">{title}</h4>
        <CopyButton text={systemPrompt} size="sm" label={`Copy ${title.toLowerCase()}`} />
      </div>

      {systemPrompt ? (
        isSystemPrompt ? (
          <div
            className="rounded p-2 border overflow-auto flex-1"
            style={{
              backgroundColor: palette.neutrals.panelSecondary,
              borderColor: palette.borders.subtle,
            }}
          >
            <span
              className={`${components.badge.padding} ${components.badge.rounded} ${components.badge.size} ${components.badge.weight} font-mono`}
              style={{
                backgroundColor: `color-mix(in srgb, ${palette.accents.secondary.base} 18%, transparent)`,
                color: palette.accents.secondary.base,
              }}
            >
              SYSTEM
            </span>
            <span
              className="font-mono mx-1.5 text-[10px]"
              style={{ color: palette.text.muted }}
            >
              -&gt;
            </span>
            <span
              className="text-xs whitespace-pre-wrap break-words"
              style={{ color: palette.text.primary }}
            >
              {systemPrompt}
            </span>
          </div>
        ) : (
          <div
            className="rounded p-3 text-xs font-mono whitespace-pre-wrap overflow-auto border flex-1"
            style={{
              backgroundColor: palette.neutrals.panelTertiary,
              borderColor: palette.borders.subtle,
              color: palette.support.codeText,
            }}
          >
            {systemPrompt}
          </div>
        )
      ) : (
        <div
          className="rounded p-3 border flex-1"
          style={{
            backgroundColor: palette.neutrals.panelTertiary,
            borderColor: palette.borders.subtle,
          }}
        >
          <div className="text-text-muted italic">No system prompt available</div>
        </div>
      )}
    </div>
  );
}
